
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ShipmentUploadIconComponent } from "./shipment-upload-icon.svg";

export const ShipmentUploadIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ShipmentUploadIconComponent {...props} />;
};
